/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Create_Ad_Template_SuccessInputs */

const en_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD Template created successfully.`)
};

const fr_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle de description audio créé avec succès.`)
};

const de_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Vorlage erfolgreich erstellt.`)
};

const it_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello AD creato con successo.`)
};

const ru_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблон объявления успешно создан.`)
};

const es_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla de AD creada exitosamente.`)
};

const zh_cn2_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD模板创建成功。`)
};

const ja_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD テンプレートが正常に作成されました。`)
};

const hi_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD टेम्पलेट सफलतापूर्वक बनाया गया।`)
};

const pt_pt2_event_group_options_create_ad_template_success = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de anúncio criado com sucesso.`)
};

/**
* | output |
* | --- |
* | "AD Template created successfully." |
*
* @param {Event_Group_Options_Create_Ad_Template_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template_success = /** @type {((inputs?: Event_Group_Options_Create_Ad_Template_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_Template_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_create_ad_template_success(inputs)
	if (locale === "de") return de_event_group_options_create_ad_template_success(inputs)
	if (locale === "it") return it_event_group_options_create_ad_template_success(inputs)
	if (locale === "ru") return ru_event_group_options_create_ad_template_success(inputs)
	if (locale === "es") return es_event_group_options_create_ad_template_success(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_create_ad_template_success(inputs)
	if (locale === "ja") return ja_event_group_options_create_ad_template_success(inputs)
	if (locale === "hi") return hi_event_group_options_create_ad_template_success(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_create_ad_template_success(inputs)
	return en_event_group_options_create_ad_template_success(inputs)
});